export function getIsPdp() {
  return new URLSearchParams(window.location.search).get('isPdp') === 'true';
}

export function getPrimaryButtonColors(theme) {
  const backgroundColor = theme.palette.primary.main;
  return { backgroundColor, color: theme.palette.getContrastText(backgroundColor) };
}
